import React from 'react';
import { inject, observer } from 'mobx-react';
import injectSheet from 'react-jss';
import { debounce } from 'lodash';

import SearchChannels from './SearchChannels';
import ChannelsList from './ChannelsList';
import Text from '../Text';

@inject('store', 'channels') @observer
class ChannelSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            isSearching: false,
            searchError: false,
            searchResults: [],
            expandChannels: false
        };

        this.toggleShowChannels = this.toggleShowChannels.bind(this);
    }

    componentDidMount() {
        this.props.channels.fetchChannels()
    }

    toggleShowChannels(e) {
        this.setState({
            expandChannels: !this.state.expandChannels
        });
    }

    render() {
        const { classes, channels, store: {channel: currentChannel} } = this.props;
        const channelsList = channels.channels;
        return (
            <div className={classes.channelsSelectorContainer}>
                <SearchChannels/>
                <Text type="h3">
                    <span className={classes.header} onClick={this.toggleShowChannels}>Channels</span>
                <ChannelsList currentChannel={currentChannel} channels={channelsList} expanded={this.state.expandChannels}/>
                </Text>
            </div>
        );
    }
}

const loadingKeyframes =
    `@-webkit-keyframes loadingAnimation {
        0% {-webkit-transform:translate(0, 0)} 
        100% {-webkit-transform:translate(100%, 0)}
    }`;

const styles = theme => ( {
    channelsSelectorContainer: {
        minWidth: 290,
        maxWidth: 290,
        paddingRight: theme.spacing,
        marginBottom: theme.spacing,
        position: 'relative',

        [ theme.devices.large ]: {
            paddingRight: 0,
            width: '100%',
            maxWidth: 'none',
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        [ theme.devices.small ]: {
            maxWidth: theme.tables.small.maxWidth
        }
    },
    header: {
        display: 'block',
        paddingTop: theme.spacing * 4,
        paddingBottom: theme.spacing * 4,
        textAlign: 'center',
        backgroundColor: theme.backgrounds.card,
        marginBottom: 0,
        borderTopLeftRadius: theme.borderRadius,
        borderTopRightRadius: theme.borderRadius,
        borderBottom: `1px ${theme.palette.border} solid`,
        boxShadow: theme.boxShadow,
        position: 'relative',
        zIndex: 2
    },
} );

export default injectSheet(styles)(ChannelSelector);



// WEBPACK FOOTER //
// ./src/app/components/channelSelector/ChannelSelector.js